import { render, staticRenderFns } from "./LabView.vue?vue&type=template&id=461e336c&scoped=true&"
import script from "./LabView.vue?vue&type=script&lang=js&"
export * from "./LabView.vue?vue&type=script&lang=js&"
import style0 from "./LabView.vue?vue&type=style&index=0&id=461e336c&prod&lang=scss&scoped=true&"
import style1 from "./LabView.vue?vue&type=style&index=1&id=461e336c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e336c",
  null
  
)

export default component.exports